import slice from './slice';

const appInstanceReducer = slice.reducer;

export const {
  setFieldIDPClients,
  addItemIDPClients,
  removeItemIDPClients,
} = slice.actions;

export default appInstanceReducer;
